import "./index.scss";

import { Box, Grid, Stack } from "@mui/material";
import { StrengthProgram } from "models/workoutplan";
import { memo, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

const WorkoutPlanStrengthSpecifySettings = (props: {
  programs: StrengthProgram[];
  selectedProgram: string;
}) => {
  const { programs, selectedProgram } = props;
  const [program, setProgram] = useState<StrengthProgram>();
  const formContext = useFormContext();
  const { setValue } = formContext;

  useEffect(() => {
    if (programs && selectedProgram) {
      setProgram(programs.find((f) => f.nanoId === selectedProgram));
    }
  }, [programs, selectedProgram]);

  const [machineSettingsCount, setMachineSettingsCount] = useState<Record<number, number>>({});
  const machineSettingsLength = 40;

  //#region event handlers
  const handleUpdateMachineSettings = (id: number, v: string) => {
    let newList = [...programs];
    let entryToEdit = newList.find((f) => f.nanoId === selectedProgram);
    let exerciseToEdit = entryToEdit.exercises.find((f) => f.id === id);
    exerciseToEdit.settings = v;
    setProgram({ ...entryToEdit });
    setValue("strength_workouts", newList);

    const newCounts = { ...machineSettingsCount };
    newCounts[id] = v.length;
    setMachineSettingsCount(newCounts);
    console.log(`machineSettingsCount ${JSON.stringify(machineSettingsCount)}`);
  };
  //#endregion event handlers

  return (
    <Stack className="primary-details-section">
      <h2 className="headerSpacing">{program?.name}</h2>
      <h2 className="headerSpacing">Exercises</h2>
      <Box className="inner-container program-exercise-grid">
        <Grid container className="program-selection-container">
          <Grid item xs={4} className="header">
            Exercise
          </Grid>
          <Grid item xs={8} className="header">
            Machine Settings
          </Grid>
          {program?.exercises.map((e) => (
            <Grid mb={1} container className="strength-exercise-settings">
              <Grid item xs={4} className="specifySettings-header">
                {e.name}
              </Grid>
              <Grid item xs={7} className="specifySettings-header" width="100px">
                <input
                  value={e.settings}
                  onChange={(v) => handleUpdateMachineSettings(e.id, v.target.value)}
                  maxLength={machineSettingsLength}
                />
              </Grid>
              <Grid item xs={1} className="header">
                {machineSettingsCount[e.id] == null ? 0 : machineSettingsCount[e.id]}/
                {machineSettingsLength}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Stack>
  );
};
export default memo(WorkoutPlanStrengthSpecifySettings);
